"use strict";
(function (Drupal, once) {
    Drupal.behaviors.closeExpandedMenu = {
        closeAllExpandedMenus: function () {
            const expandedMenuElements = document.querySelectorAll('.js-expanded-menu');
            // Remove all the js-expanded-menu elements from the DOM
            expandedMenuElements.forEach(function (expandedMenuElement) {
                expandedMenuElement.remove();
            });
            // Allow scroll on body again
            document.body.style.overflow = 'visible';
        },
        attach: function (context) {
            // Get the logo and menu wrapper
            const logoAndMenuWrapper = document.querySelector('.js-logo-and-menu-wrapper');
            once('closeExpandedMenu', '.js-close-expanded-menu', context).forEach(function (element) {
                element.addEventListener('click', function (event) {
                    // Reset the top level menu chevrons
                    Drupal.behaviors.resetTopLevelMenuChevrons.attach(document, Drupal.settings);
                    // Reset the previous clicked element id variable to empty string
                    Drupal.behaviors.openExpandedMenu.previousClickedElementID =
                        '';
                    // Get all the js-expanded-menu elements
                    const expandedMenuElements = document.querySelectorAll('.js-expanded-menu');
                    // Get the top level menu items
                    const topLevelMenuItems = document.querySelectorAll('.js-top-level-menu-item');
                    // Get the toggle cta element
                    const toggleCTAElement = document.querySelector('.js-toggle-call-to-action');
                    // Show the toggle cta element
                    if (toggleCTAElement) {
                        toggleCTAElement.classList.remove('hidden');
                    }
                    // Remove all the js-expanded-menu elements from the DOM
                    expandedMenuElements.forEach(function (expandedMenuElement) {
                        expandedMenuElement.remove();
                    });
                    // Allow scroll on body again
                    document.body.style.overflow = 'visible';
                    // Remove new hover classes to the top level menu items
                    topLevelMenuItems.forEach((topLevelMenuItem) => {
                        topLevelMenuItem.classList.remove('hover:rounded-b-none', 'hover:rounded-t-3xl', 'pb-8');
                    });
                    // Add align-items: flex-end to the logo and menu wrapper
                    if (logoAndMenuWrapper) {
                        // Remove items-center
                        logoAndMenuWrapper.classList.add('items-center');
                        // Add items-end
                        logoAndMenuWrapper.classList.remove('items-end');
                    }
                });
            });
        },
    };
})(Drupal, once);
